export function getExt(name) {
  return name.match(/\.([^.]+)$/)?.[0]
}
